import { ProjectRole, userDocumentSchema } from "../../types/firestore";
import { useMemo } from "react";
import { doc, getFirestore } from "firebase/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import roleNames from "../../modules/roleNames";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const auth = getAuth();
const firestore = getFirestore();

export interface UserProps {
	projectId: string;
	userId: string;
	userRole: ProjectRole;
}

export default function User(props: UserProps) {
	const navigate = useNavigate();

	const userDocumentRef = useMemo(
		() =>
			doc(firestore, "Users", props.userId).withConverter(
				getFirestoreZodConverter(userDocumentSchema),
			),
		[props.userId],
	);

	const [user] = useAuthState(auth);

	const [userDocument] = useDocumentData(userDocumentRef);

	if (!user) return <div></div>;

	return (
		<Card role="button" className="mb-2 clickable-card" onClick={() => navigate(props.userId)}>
			<Card.Body>
				<Row>
					<Col xs="auto">
						<i className="bi bi-file-earmark-person fs-1" />
					</Col>
					<Col className="d-flex align-items-center">
						<div>
							<div>
								{userDocument?.FirstName} {userDocument?.LastName}
							</div>
							<small className="text-muted">{roleNames[props.userRole]}</small>
						</div>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
}
